module.exports = __webpack_public_path__ + "img/logo.d4ff7329.png";